import React, {ReactNode} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import PortalDocument from "../../PortalDocument";
import {I18nGlobals} from "../../../../shared/translation/i18nInterface";
import PortalContext from "../../../PortalContext";
import Translate from "../../../../shared/translation/Translate";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {MetadataPassword} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import PortalPureComponent from "../../../../shared/components/PortalPureComponent";

export interface DocumentSecurityProperties extends I18nGlobals {
	context: PortalContext;
}

export default class DocumentSecurity extends PortalPureComponent<DocumentSecurityProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let selection: Array<PortalDocument> = this.props.context.documentManager.getSelection();

		if (selection.length === 0) {
			return (
				<p className="no-results">
					<Translate {...this.props} data="security.no_results" namespace="sidebar"/>
				</p>
			);
		}

		let selected: PortalDocument = selection[0];

		let values: Array<{ label: any, value: any }> = [
			{
				label: <Translate {...this.props} data="security.open_password" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.hasPasswordProtection("open") ?
						"security.values.yes" : "security.values.no"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.permission_password" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.hasPasswordProtection("permission") ?
						"security.values.yes" : "security.values.no"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.certificate" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.hasCertificateProtection() ?
						"security.values.yes" : "security.values.no"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_assemble" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canAssemble ? "security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_extract_content" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canExtractContent ?
						"security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_extract_for_accessibility" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canExtractForAccessibility ?
						"security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_fill_in_form" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canFillInForm ? "security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_modify" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canModify ? "security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_modify_annotations" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canModifyAnnotations ?
						"security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_print" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canPrint ? "security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			},
			{
				label: <Translate {...this.props} data="security.can_print_high_res" namespace="sidebar"/>,
				value: <Translate {...this.props} data={
					selected.metadata?.security?.canPrintHighRes ?
						"security.values.allowed" : "security.values.forbidden"
				} namespace="sidebar"/>
			}
		];

		let keyAlgorithm: string = FunctionHelper.applyValue(
			selected.metadata?.security?.password?.keyAlgorithm, MetadataPassword.getKeyAlgorithmDefault()
		);
		if (keyAlgorithm !== "none") {
			values.push(
				{
					label: <Translate {...this.props} data="security.key_algorithm" namespace="sidebar"/>,
					value: <Translate {...this.props} data="security.values.key_algorithm" namespace="sidebar"
									  values={{
										  keyLength: selected.metadata?.security?.password?.keyLength,
										  keyAlgorithm: keyAlgorithm.toUpperCase()
									  }}/>
				}
			);
		}

		return (
			<DataTable value={values} responsiveLayout={"scroll"}>
				<Column field="label"/>
				<Column field="value"/>
			</DataTable>
		);
	}
}